<template>
  <v-fade-transition mode="out-in">
    <router-view/>
  </v-fade-transition>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data: () => ({
    routes: [
      {
        //to: "/student/placements",
        to: "/student",
        text: "Placements"
      }
      /*{
        to: "/student/instruction",
        text: "Instructions"
      }*/
    ]
  }),
  methods: {
    ...mapMutations(["setRoutes"])
  },
  mounted() {
    this.setRoutes(this.routes);
  }
};
</script>
